import { message } from "antd";
import { UpdateCalculationSetting } from "../../api/UpdateCalculationSetting";
import { useAPIResponse } from "../global/useApiResponse";

export const useUpdateCalculationSetting = async (
  calculation_setting_id: number,
  payload: any
) => {
  await message.loading("Updating Calculation Setting..", 2);

  const response = await UpdateCalculationSetting(calculation_setting_id, payload);

  return useAPIResponse(response);
};
